import { promiseWrapper } from 'utils/promise'
import { SettingsResponse, SettingsKeys } from 'models/settings'

declare const USER_BASE_URL_WT: string

export const fetchSupportedCurrencyPairs = (): Promise<SettingsResponse> => {
  return promiseWrapper<SettingsResponse, null>(
    `${USER_BASE_URL_WT}/api/public/settings?keys[]=market-currency-pairs`,
    'GET',
  )
}

export const fetchDataForSavingsCalculator = (): Promise<SettingsResponse> => {
  return promiseWrapper<SettingsResponse, null>(
    `${USER_BASE_URL_WT}/api/public/settings?keys[]=market-currency-pairs&keys[]=currency`,
    'GET',
  )
}

export const fetchDataForForeignCalculator = async (): Promise<SettingsResponse> => {
  return promiseWrapper<SettingsResponse, never>(
    `${USER_BASE_URL_WT}/api/public/settings?keys[]=currency&keys[]=direct-exchange-minimal-amounts&keys[]=minimal-payout-amounts&keys[]=currencies-not-supported&keys[]=bank-transfer-countries`,
    'GET',
  )
}

export const fetchSettings = async (keys: SettingsKeys[]): Promise<SettingsResponse> => {
  const url = `${USER_BASE_URL_WT}/api/public/settings?keys[]=${keys.join('&keys[]=')}`
  return promiseWrapper<SettingsResponse, never>(url, 'GET')
}
